import axios from "axios";
import Config from "../../Config";
import { getToken, removeToken } from "../../utils/token";
import { persistor } from '../../redux/store';


// * Register A User
export const registerUser = async (values) => {
  const requestData = {
    brand_name: values.brandName,
    phone_number: values.phoneNumber,
    location: values.location,
    email: values.email,
    region: values.region,
    brand_category: values.preferredCategory,
    website: values.websiteLink || "",
    facebook: values.facebookLink || "",
    instagram: values.instagramLink || "",
    twitter: values.twitterLink || "",
    password: values.password,
    password_confirmation: values.confirmPassword,
  };
  if (values.logo) {
    const base64Logo = await convertFileToBase64(values.logo);
    requestData.logo = base64Logo;
  }

  try {
    const response = await axios.post(
      Config.backendDomain + "vendor/register",
      requestData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    // Make sure to throw the error so it can be caught by the mutation
    throw error;
  }
};

//* Helper function to convert File to base64
const convertFileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};

const api = axios.create({
  baseURL: "https://backend.dealboxx.promo/api",
});
api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const loginUser = async (userData) => {
  try {
    const response = await api.post("/vendor/login", userData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const logoutUser = async () => {
  try {
    const token = getToken();
    const response = await api.post("/vendor/logout", {}, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const forgotPassword = async (data) => {
  const response = await api.post("/vendor/email/resetpassword", data);
  return response;
};

export const resetPassword = async (data) => {
  const response = await api.post("/vendor/resetpassword", data);
  return response.data;
};

export const resendOtp = async (data) => {
  const response = await api.post("vendor/resend/verificationCode", data);
  return response.data;
};
